import { createToasterThings } from 'svag-toaster'

export const { Toaster, toast } = createToasterThings({
  defaultPosition: 'top-center',
})
